/********************************************
 * Product carousel tabs
 ********************************************/
function fnProductCarouselTabs(i, oSection) {

    /*****************
	* Objects
	*****************/
    var oSection 					= $( oSection ),
        oCarousel 					= $( '.slick-slider', oSection );


    /*****************
	* Carousel configuration
	*****************/
	// Set same height to all products
	oCarousel.on( 'setPosition', function() {

		$( this ).find( '.slick-slide' ).height( 'auto' );
		var slickTrack = $( this ).find('.slick-track');
		var slickTrackHeight = $( slickTrack ).height();
		$( this ).find( '.slick-slide' ).css( 'height', slickTrackHeight + 'px' );

	});

	// Initialise slider
    oCarousel.slick({
		touchThreshold:   	 		20,
		autoplay:   	      		false,
		autoplaySpeed:   	      	5000,
		dots:   	          		false,
		arrows:   	        		true,
		infinite:   	        	false,
		slidesToShow: 				4,
		speed:   	         		500,
		variableWidth:				true,
		adaptiveHeight:   			false,
		mobileFirst:   	   			true,
		focusOnSelect:   	 		false,
		responsive: [
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					centerMode: false,
					slidesToShow: 4
				}
			}, {
				breakpoint: 0,
				settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '40px',
            		infinite: true,
					slidesToShow: 1
				}
			}
		]
    });

}


// END OF DOCUMENT
